"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavIconLinks = void 0;
var FavIconLinks_1 = require("./FavIconLinks");
Object.defineProperty(exports, "FavIconLinks", { enumerable: true, get: function () { return FavIconLinks_1.FavIconLinks; } });
//# sourceMappingURL=index.js.map